//Check value is in range
//PASS: value is valid, returns true
//FAIL: value is invalid, returns false
export const CheckValueInRange = ({ value, min, max }) =>
  value >= min && value <= max;
